
import { Component, Vue } from 'vue-property-decorator'
import { passwordValidator, checkPasswordValidator } from '../../utils/validator'
@Component
/**
 * 内置方法 通过this.$refs.cropper 调用
 this.$refs.cropper.startCrop() 开始截图
  this.$refs.cropper.stopCrop() 停止截图
  this.$refs.cropper.clearCrop() 清除截图
  this.$refs.cropper.changeScale() 修改图片大小 正数为变大 负数变小
  this.$refs.cropper.getImgAxis() 获取图片基于容器的坐标点
  this.$refs.cropper.getCropAxis() 获取截图框基于容器的坐标点
  this.$refs.cropper.goAutoCrop 自动生成截图框函数
  this.$refs.cropper.rotateRight() 向右边旋转90度
  this.$refs.cropper.rotateLeft() 向左边旋转90度
  图片加载的回调 imgLoad 返回结果success, error
  获取截图信息
  this.$refs.cropper.cropW 截图框宽度
  this.$refs.cropper.cropH 截图框高度
  */
export default class ModifyAvatar extends Vue {
  private showDialog: boolean = false
  private uploadImg: any = ''
  private cropperHtml: any= ''
  private submitLoading: boolean = false
  private option: any = {
    img: '', // 裁剪图片的地址
    info: false, // 裁剪框的大小信息
    outputSize: 1, // 裁剪生成图片的质量
    outputType: 'png', // 裁剪生成图片的格式
    canScale: true, // 图片是否允许滚轮缩放
    autoCrop: true, // 是否默认生成截图框
    autoCropWidth: 89, // 默认生成截图框宽度
    autoCropHeight: 89, // 默认生成截图框高度
    fixed: false, // 是否开启截图框宽高固定比例
    fixedNumber: [1, 1], // 截图框的宽高比例
    fixedBox: false, // 固定截图框大小 不允许改变
    full: false, // 是否输出原图比例的截图
    canMove: false, // 上传图片是否可以移动
    canMoveBox: true, // 截图框能否拖动
    original: false, // 上传图片按照原始比例渲染
    centerBox: true, // 截图框是否被限制在图片里面
    high: false, // 是否按照设备的dpr 输出等比例图片
    infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
    maxImgSize: 2000, // 限制图片最大宽度和高度
    enlarge: 1, // 图片根据截图框输出比例倍数
    mode: 'contain', // 图片默认渲染方式 contain , cover, 100px, 100% auto
  }
  public show() {
    this.showDialog = true
  }
  public cancel() {
    this.showDialog = false
  }
  onUploadChange(file: any) {
    const isLt5M = file.size / 1024 / 1024 < 5
    if (!isLt5M) {
      this.$message.error('上传文件大小不能超过 5MB!')
      return false
    }
    var reader = new FileReader()
    reader.readAsDataURL(file.raw)
    reader.onload = (event: any) => {
      this.uploadImg = event.target.result// base64
      this.option.img = event.target.result// base64
    }
  }
  private realTime(data: any) {
    if (data.url) {
      this.cropperHtml = data.html
    }
  }
  private handleResetUpload() {
    this.uploadImg = ''
    this.option.img = ''
    this.cropperHtml = ''
  }
  private changeScale(scale: number) {
    (this.$refs.cropper as any).changeScale(scale)
  }
  private rotateLeft(scale: number) {
    (this.$refs.cropper as any).rotateLeft()
  }
  private rotateRight(scale: number) {
    (this.$refs.cropper as any).rotateRight()
  }
  imgLoad(msg: any) {
    console.log(`[Cropper]: ${msg}`)
  }
  finish() {
    (this.$refs.cropper as any).getCropData((data: any) => {
      // 截图图片
      console.log(data)
    })
  }
}
